'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagJoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 0L28 8.89599e-06C28 6.66668 28 13.3333 28 20C18.6667 20 9.33335 20 1.24276e-05 20C1.24276e-05 13.3333 9.25249e-05 6.66667 0 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.24276e-05 20H28V13.3333H1.24276e-05V20Z",
          fill: "#199E56"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.24276e-05 6.66668H28V8.89599e-06L0 0L1.24276e-05 6.66668Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 0L13.3333 10L1.24276e-05 20L0 0Z",
          fill: "#E6223A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66668 11L3.79891 11.8019L3.88485 10.6235L2.71682 10.445L3.69175 9.77749L3.10302 8.75303L4.2328 9.09904L4.66668 8.00001L5.10056 9.09904L6.23034 8.75303L5.64161 9.77749L6.61654 10.445L5.44851 10.6235L5.53445 11.8019L4.66668 11Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagJoAsset = forwardRef(FlagJoAsset);

export { VpFlagJoAsset as default };
